import { censusGraphs } from '../../../packages/configs/census-graphs';
import {
  census,
  getReportHeader,
  heatmap,
  impact,
  salesIndicators,
} from '../../../packages/configs/multi-parcel-report';

export const multiparcelReport = {
  id: 'MULTI_PARCEL_REPORT',
  sections: [
    {
      title: 'Multi-Parcel Report',
      titleSelector: 'layer.label',
      properties: [
        ...getReportHeader(),
        ...salesIndicators({ after: 2009 }),
        ...impact(),
        {
          label: 'Has Structure(s)',
          type: 'TITLE',
          newPage: true,
        },
        {
          label: 'Has Structures',
          exclude: ['No'],
          map: {
            Yes: 'Has Structures',
          },
          graph: 'structures',
          type: 'LINE_GRAPH',
          after: 2009,
          compare: [
            {
              to: 'CITY',
              label: 'No Structure for the city',
            },
          ],
        },
        {
          label: 'General Zoning',
          graph: 'general_zoning_parcels',
          type: 'PIE_GRAPH',
          compare: [
            {
              to: 'CITY',
              graph: 'general_zoning_parcels',
              label: 'Zoning for the city',
            },
          ],
        },
        {
          label: 'Zoning',
          graph: 'zoning_parcels',
          type: 'PIE_GRAPH',
          compare: [
            {
              to: 'CITY',
              graph: 'zoning_parcels',
              label: 'Zoning for the city',
            },
          ],
        },
        {
          label: 'Tax Indicators',
          type: 'TITLE',
          newPage: true,
        },
        {
          label: 'Tax Status',
          exclude: ['Unknown'],
          graph: 'tax_status_parcels',
          type: 'LINE_GRAPH',
          after: 2009,
          compare: [
            {
              to: 'CITY',
              graph: 'tax_status_parcels',
              label: 'No Structure for the city',
            },
          ],
          options: {
            showPieChart: true,
          },

          map: {
            'Tax Current': 'Tax Current',
            'Tax Exempt': 'Tax Exempt',
            'Tax Delinquent': 'Tax Delinquent',
            'Tax Foreclosable': 'Tax Forfeiture',
          },
        },
        {
          label: 'Foreclosures',
          type: 'TITLE',
          newPage: true,
        },
        {
          label: 'Tax Foreclosures',
          graph: 'tax_foreclosures_parcels',
          type: 'LINE_GRAPH',
          after: 2009,
          exclude: ['Not Foreclosed'],
          compare: [
            {
              to: 'CITY',
              label: 'Tax Foreclosures for the city',
            },
          ],
        },
        {
          label: 'Mortgage Foreclosures',
          graph: 'mortgage_foreclosures_parcels',
          type: 'LINE_GRAPH',
          after: 2009,
          exclude: ['Not Foreclosed'],
          compare: [
            {
              to: 'CITY',
              label: 'Mortgage Foreclosures for the city',
            },
          ],
        },
        {
          label: 'Occupancy Indicators',
          type: 'TITLE',
          newPage: true,
        },
        {
          label: 'Occupancy',
          graph: 'occupancy_parcels',
          type: 'LINE_GRAPH',
          after: 2009,
          exclude: ['Unoccupied', 'undefined'],
          map: {
            0: 'Occupied',
            1: 'Unoccupied',
          },
          compare: [
            {
              to: 'CITY',
              graph: 'occupancy_parcels',
              label: 'Occupancy for the city',
            },
          ],
          options: {
            showPieChart: true,
          },
        },
        {
          label: 'Owner Occupancy',
          graph: 'owner_occupancy_parcels',
          exclude: ['Not Owner Occupied', 'undefined'],
          type: 'LINE_GRAPH',
          after: 2009,
          map: {
            1: 'Owner Occupied',
            0: 'Not Owner Occupied',
          },
          compare: [
            {
              to: 'CITY',
              graph: 'owner_occupancy_parcels',
              label: 'No Structure for the city',
            },
          ],
        },
        ...census(),
        ...censusGraphs(),
        ...heatmap(),
      ],
    },
  ],
};
